export const Routing = {
  INVITE_USERS_PAGE: '/users/invite',
  LOGIN_PAGE: '/login',
  HOME_PAGE: '/',
  USERS_PAGE: '/users',
};
